import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { solution } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_SOLUTION_BY_ID({ commit }: any, solutionId: number) {
    const response = await query(
      `query PullSolution($solutionId: Int!) {
        solutionById(id: $solutionId) {
          id
          questionId
          userId
          contentsBySolutionId {
            nodes {
              id
              position
              solutionId
              textByTextId {
                id
                body
                alignment
                source
              }
              imageByImageId {
                id
                url
                source
                resizeFactor
                description
              }
              videoByVideoId {
                id
                providerId
                providerType
              }
            }
          }
        }
      }`,
      {
        solutionId,
      },
    );
    let normalizedResponse = normalize(response.data.solutionById, solution);
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },

  async PUSH_SOLUTION_BY_ID({ dispatch, getters }: any, solutionId: number) {
    let solution = getters.solutionById(solutionId);

    return Promise.all([
      dispatch('UPDATE_CONTENTS', solution.contents()),
      mutation(
        `mutation updateSolution ($id: Int!, $content: JSON!) {
          updateSolutionById(input: {
            id: $id
            solutionPatch: {
              content: $content
              draft: false
            }
          }) {
            solution {
              id
              content
            }
          }
        }`,
        solution.raw(),
      ),
    ]);
  },

  async CREATE_SOLUTION({ commit, rootState }, questionId: number) {
    let userId = rootState.auth.user.id;
    let response = await mutation(
      `mutation CreateSolution($userId: Int!, $questionId: Int!) {
        createSolution(input: {
          solution: {
            userId: $userId
            draft: true
            questionId: $questionId
          }
        }) {
          solution {
            id
            questionId
          }
        }
      }`,
      {
        userId,
        questionId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'solutions',
      data: response.data.createSolution.solution,
    });
    return response.data.createSolution.solution.id;
  },
};
